/**
 * Self-Improving Workflow Demo — demo-mode flag (thin wrapper over the shared
 * framework).
 *
 * THROWAWAY DEMO CODE. The generic multi-demo flag lives in
 * `@/demo/core/demo-mode`; this binds the workflow-recovery key on top.
 *
 * Start it from the hidden Cmd+K command (type "demo"); see `@/demo/command`.
 */

import { isDemoActive } from '@/demo/core/demo-mode';

export const WORKFLOW_RECOVERY_DEMO_KEY = 'wf';

/** True when the self-improving workflow demo is active for this tab. */
export function isWorkflowRecoveryDemo(): boolean {
  return isDemoActive(WORKFLOW_RECOVERY_DEMO_KEY);
}
